<template>
    <div class="justify-content-center">
        <b-alert variant="danger"
                 :show="dismissCountDown"
                 @dismissed="dismissCountDown=0"
                 @dismiss-count-down="countDownChanged"
                 dismissible
        >
            {{ getErrorsField('accessRefuse') }}
            {{ getErrorsField('dejaAffilie') }}
            {{ getErrorsField('nonTransmis') }}
            {{ getErrorsField('uniqueDossier') }}
            {{ getErrorsField('notSendMail') }}
        </b-alert>
    </div>
</template>

<script>
    import { mapGetters } from 'vuex';
    export default {
        name: "BaseNotification",
        computed: {
            ...mapGetters(["errors"]),
        },
        data() {
            return {
                show: false,
                dismissSecs: 10,
                dismissCountDown: 0
            }},

        methods: {
            getErrorsField(field){
                if (this.errorshasField(field)){
                    return this.errors[field][0];
                }else{
                    return  '';
                }
            },
            countDownChanged(dismissCountDown) {
                this.dismissCountDown = dismissCountDown;
                if (this.dismissCountDown == 0){
                     this.clearErrorField('accessRefuse') ;
                    this.clearErrorField('dejaAffilie');
                    this.clearErrorField('nonTransmis');
                    this.clearErrorField('uniqueDossier');
                    this.clearErrorField('notSendMail') ;
                }
            },
            showAlert() {
                this.dismissCountDown = this.dismissSecs
            },
            errorshasField(field){
                let result = this.errors ? this.errors.hasOwnProperty(field) : false;
                if(result == true){
                    this.show = true;
                    this.showAlert();
                }
                return result;
            },

            clearErrorField(field){
                this.$store.dispatch('clearErrorField', { field });

                this.getErrorsField(field);
            }
        }
    }
</script>

<style scoped>

</style>